import { apiRoot, externalHost, resourceHost, imageResourceHost, assetResourceHost } from './environment'
import defaultConfigs from './configs/common'

export const getLabelForCountry = iso2 => {
  const countries = config.countries.filter(obj => obj.iso2 === iso2)
  return countries.length > 0 ? countries[0] : ''
}

export const PASSWORD_CHECK_RULES = {
  // any password
  any: /^.*$/,
  // at least 8 characters, must include at least one of each lower case
  // letter and one upper case letter OR numeric digit
  charsMin1UpperAndLower: /^(?=.*[a-z])((?=.*[A-Z])).{1,}$/,
  charsMin8UpperAndLowerOrNumeric: /^(?=.*[a-z])((?=.*[A-Z])|(?=.*\d)).{8,}$/,
  // at least 8 characters, must include at least one lower case
  // letter and special character and one upper case letter OR or one numeric digit
  charsMin8UpperAndLowerAndSpecialOrNumeric: /^(?=.*[a-z])((?=.*[A-Z])|(?=.*\d))(?=.*[^A-Za-z0-9]).{8,}$/,
  charsMin1SpecialOrNumeric: /^((?=.*[^A-Za-z0-9])|(?=.*\d)).{1,}$/,
  // at least 12 characters, must include at least one lower case
  // letter and special character and one upper case letter OR or one numeric digit
  charsMin12UpperAndLowerAndSpecialOrNumeric: /^(?=.*[a-z])((?=.*[A-Z])|(?=.*\d))(?=.*[^A-Za-z0-9]).{12,}$/,
}

const config = {
  ...defaultConfigs,

  apiRoot,
  externalHost,
  resourceHost,
  // resource endpoints
  imageResourceHost,
  assetResourceHost,

  agbUrl: 'https://www.buhl.de/go/11592',
  imprintUrl: 'https://www.buhl.de/go/11591',
  privacyUrl: 'https://www.buhl.de/go/11590',
  psd2Url: 'https://www.buhl.de/meinbuero/was-aendert-sich-durch-psd2/',
  customerSupport: 'https://www.buhl.de/mein-buhlkonto/support/',
  remoteAssistance: 'https://www.buhl.de/go/46413',
  remoteAssistanceButton: 'https://www.buhl.de/go/46414',
  faqUrl: 'https://www.buhl.de/go/28614',
  mailboxUrl: 'https://www.buhl.de/go/35666',
  webinarUrl: 'https://www.buhl.de/go/44727',
  quickStartGuideUrl: 'https://www.buhl.de/go/32419',
  hubspotMeetingScheduler: 'https://www.buhl.de/go/45949',

  playStoreUrl: 'https://www.buhl.de/go/11919',
  iTunesUrl: 'https://www.buhl.de/go/11918',
  playStoreDocumentUrl: 'https://play.google.com/store/apps/details?id=com.BuhlData.MeinBueroScan&hl=de',
  appStoreDocumentUrl: 'https://apps.apple.com/de/app/wiso-meinb%C3%BCro-dokumente/id6461420211',

  marketingUrl: 'https://www.buhl.de/buero/wiso-meinbuero-rechnungen-app/',
  aiChatProductUrl: 'https://www.buhl.de/buero/wiso-meinbuero-rechnungen-app/',
  marketingUrlDocuments: 'https://www.buhl.de/buero/wiso-meinbuero-dokumente-app/',

  eInvoiceUrl: 'https://www.buhl.de/go/30275',

  webSocketUrl: `${(window?.location?.protocol === 'https:' ? 'wss:' : 'ws:')}${resourceHost.replace('https:', '')}websocket`,

  currencyFormat: {
    symbol: '€',
    format: '%v %s',
    decimal: ',',
    thousand: '.',
    precision: 2,
  },

  // date formats
  dateFormat: {
    api: 'YYYY-MM-DD',
    client: 'DD.MM.YYYY',
    dateTime: 'DD.MM.YYYY - hh:mm',
    weekDay: 'dddd',
  },

  monthNames: [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
  ],

  dateEpochValue: '1899-12-30',
  datetimeEpochValue: '1899-12-30T00:00',

  // date + time formats
  datetimeFormat: {
    api: 'YYYY-MM-DDTHH:mm',
    client: 'H:mm',
    dateTime: 'DD.MM.YYYY - hh:mm',
    dateTime24: 'DD.MM.YYYY - HH:mm',
  },

  // default request timeout
  requestTimeout: 2e4,
  requestExtraLongTimeout: 10e5,

  // default page title
  documentTitleSuffix: 'WISO MeinBüro',

  dashboardBannerUrls: {
    imageUrl: 'https://www.buhl.de/go/13337',
    linkUrl: 'https://www.buhl.de/go/13338',
  },

  dashboardBannerPaidUrls: {
    imageUrl: 'https://www.buhl.de/go/46498',
    linkUrl: 'https://www.buhl.de/go/46497',
  },

  accountBannerUrls: {
    imageUrl: 'https://www.buhl.de/go/18499',
    linkUrl: 'https://www.buhl.de/go/18378',
  },

  // tax-consulant-callback-url
  taxConsultantCallbackUrl: 'https://book.timify.com?accountId=60229d9152442910d3ac16f0&serviceId=623078a76b84e9220d8cca12&overlayColor=#023e84&overlayOpacity=0.8&showGuestBookingForm=true&hideCloseButton=1',

  // "Kostenlose Einrichtungsberatung" after a purchase in the checkout (orgaMAX only, kept in sync)
  setupConsultationUrl: 'https://www.buhl.de/go/45949',

  // product information urls
  productInfoLinks: {
    mainInfoUrl: 'https://www.buhl.de/buero/wiso-meinbuero-rechnungen/',
    documentInfoUrl: 'https://www.buhl.de/buero/wiso-meinbuero-dokumente/',
    staffInfoUrl: 'https://www.buhl.de/buero/wiso-meinbuero-personal/',
  },
  economicAsset: {
    mainInfoUrl: 'https://www.buhl.de/go/28540',
  },

  taxReports: {
    euer: {
      faqUrl: 'https://www.buhl.de/go/36563',
    },
  },
}

export default config
